import React, { useState, useRef, useEffect, useCallback } from 'react';
import Hls from 'hls.js';
import { Card, CardBody, CardTitle } from 'reactstrap';

const VideoPlayerCard = (props) => {
  const [playerSource, setPlayerSource] = useState(null);
  const playerRef = useRef();
  const [errorMessage, setErrorMessage] = useState(null);

  const getStartPos = useCallback((src) => {
    const playData = JSON.parse(localStorage.getItem('playData')) || {};
    if (playData[src] && playData[src].currentTime) return playData[src].currentTime;
    else return 0; // Default to 0 if no saved time
  }, []);

  useEffect(() => {
    const src = props.link;
    //Funkar
    //const src = "https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8"
    //const src = "http://devimages.apple.com/iphone/samples/bipbop/bipbopall.m3u8"
		//const src = "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8"	//cyber
		//const src = "https://multiplatform-f.akamaihd.net/i/multi/will/bunny/big_buck_bunny_,640x360_400,640x360_700,640x360_1000,950x540_1500,.f4v.csmil/master.m3u8"

    setPlayerSource(src);
    //setPlayerSource(decodeURIComponent(src)); //Doesn't make a difference
  }, [props.link]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (playerRef.current) {
        let playData = JSON.parse(localStorage.getItem('playData')) || {};
        playData[playerSource] = playData[playerSource] || {};
        playData[playerSource].currentTime = playerRef.current.currentTime;
        localStorage.setItem('playData', JSON.stringify(playData));
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [playerSource]);

  useEffect(() => {
    const loadVideo = async () => {
      const video = playerRef.current;
      video.crossOrigin = 'anonymous'; // Ensure cross-origin handling

      
      if (Hls.isSupported()) {
        console.log('HLS.js supported. Using it');
        const hls = new Hls();
        hls.loadSource(playerSource);
        hls.attachMedia(video);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          const startPos = getStartPos(playerSource);
          hls.startLoad(startPos);
          video.currentTime = startPos;
          video.play();
        });

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error('HLS error:', data);
          setErrorMessage(`HLS fel: ${data.details}`);
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          console.log('HLS.js not supported, but Native HLS is. Using it');
          video.src = playerSource;
          video.addEventListener('loadedmetadata', () => {
            const startPos = getStartPos(playerSource);
            video.currentTime = startPos;
            video.play();
          });
      } else {
        console.error('Hls not supported. Native HLS not supported.');
        setErrorMessage('Hls stöds ej. Native HLS stöds ej.');
      }
    };

    if (playerSource) {
      loadVideo();
    }
  }, [playerSource, getStartPos]);

  const handleError = (event) => {
    console.error('Error occurred while loading the video:', event);
    setErrorMessage('Ett fel inträffade när videon skulle spelas.');
  };

  const handleStalled = () => {
    console.warn('Video playback stalled');
  };

  const handleWaiting = () => {
    console.warn('Video is waiting for more data');
  };

  const handleProgress = (state) => {
    //console.log('onProgress', state);
  };

  return (
    <Card style={{ boxShadow: 'none' }} className="main-card mb-3">
      <CardBody>
        <CardTitle>
          {props.area}: {props.course}
        </CardTitle>
        {playerSource && (
          <video
            ref={playerRef}
            controls
            width={500}
            height={375}
            onError={handleError}
            onStalled={handleStalled}
            onWaiting={handleWaiting}
            onProgress={handleProgress}
          >
            Your browser does not support the video tag.
          </video>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </CardBody>
    </Card>
  );
};

export default VideoPlayerCard;